import { render, staticRenderFns } from "./Detail-Quotation.vue?vue&type=template&id=518ad714"
import script from "./Detail-Quotation.vue?vue&type=script&lang=js"
export * from "./Detail-Quotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports